import TickerWinners from './TickerWinners';

export default TickerWinners;